import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import Table from '../../components/Table';
import { useSelector } from 'react-redux';

function Stocks() {
  const [stocks, setStocks] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const nameProperty = useSelector((state) => state.nameProperty.nameProperty);

  const columns = [
    {
      title: 'Insumo',
      field: 'supply.name',
      editable: 'never',
      hideFilterIcon: true,
    },
    {
      title: 'Quantidade',
      field: 'quantity',
      editable: 'never',
      render: (rowData) => (
        <>{new Intl.NumberFormat('pt-BR').format(rowData.quantity)}</>
      ),
      hideFilterIcon: true,
    },
    /*
        {
            title: "Compra",
            field: "id",
            hideFilterIcon: true
        },
        */
    {
      title: 'Unidade',
      field: 'unity.name',
      editable: 'never',
      hideFilterIcon: true,
      // render: rowData => {
      //     return (
      //        JSON.parse(rowData.unity).name
      //     )
      // },
    },
  ];

  useEffect(() => {
    async function loadData() {
      try {
        const response = await api.get('/stocks');
        if (response.data) {
          // Ajuste provisorio
          setStocks(response.data.filter((item) => item.supply !== null));
          setOpenProgress(true);
        }
      } catch (err) {

      }
    }
    loadData();
  }, [nameProperty]);

  function setData(newData) {
    const tempData = [];
    stocks.map((stock) => (stock.id === newData.id ? tempData.push(newData) : tempData.push(stock)));
    setStocks(tempData);
  }

  return (
    <Table
      title="Estoque"
      route="/stocks/"
      routeAdd="/stock/"
      columns={columns}
      data={stocks}
      setData={setData}
      dataLoaded={openProgress}
      isVisible={false}
      copy={false}
    />
  );
}

export default Stocks;
